export default (obj) =>
  obj && obj !== null && typeof obj === "object" && !Array.isArray(obj);
